import { ICellRendererParams } from 'ag-grid-community'

export const orgStateUnitRenderer = (
  props: ICellRendererParams<{
    organizationName: string
    accessCodeSpecificState: string
    accessCodeSpecificUnitName: string
  }>,
) => {
  const { organizationName, accessCodeSpecificState, accessCodeSpecificUnitName } = props.data || {}
  const code = `${organizationName ? organizationName + '/' : ''}${
    accessCodeSpecificState ? accessCodeSpecificState + '/' : ''
  }${accessCodeSpecificUnitName || ''}`

  return code
}
